import React, { useState } from 'react';
import { useLanguage } from '../../contexts/LanguageContext';
import { useMessageModal } from '../../contexts/MessageModalContext';
import content from '../../i18n/content';
import './CodeFeature.css';

const CodeFeature = () => {
    const { lang } = useLanguage();
    const t = content[lang].codeFeature;
    const { openModal } = useMessageModal();
    const [lookingForDedicatedProgrammer, setLookingForDedicatedProgrammer] = useState(true);

    const toggleValue = () => setLookingForDedicatedProgrammer(prev => !prev);

    const handleSendClick = () => {
        if (!lookingForDedicatedProgrammer) return;
        openModal();
    };

    return (
        <div id="code-feature" className="code-feature-container">
            <pre className="code-block">
                <code>
                    <span className="code-keyword">{t.typeLabel}</span>{' '}
                    <span className="code-variable">{t.varLabel}</span>{' '}
                    ={' '}
                    <button
                        className={`code-value-button ${lookingForDedicatedProgrammer ? 'value-true' : 'value-false'}`}
                        onClick={toggleValue}
                        aria-label={`Toggle ${t.varLabel} to ${!lookingForDedicatedProgrammer}`}
                    >
                        {String(lookingForDedicatedProgrammer)}
                    </button>;
                    {'\n'}
                    <span className="code-keyword">if</span> (
                    <span className="code-variable">{t.varLabel}</span>
                    ) {'{'}
                    {'\n'}
                    {'  '}
                    <button
                        className="code-send-button"
                        onClick={handleSendClick}
                        disabled={!lookingForDedicatedProgrammer}
                        aria-label="Open send message form"
                    >
                        {t.sendBtn}
                    </button>
                    {'\n'}
                    {'}'}
                </code>
            </pre>
        </div>
    );
};

export default CodeFeature;
